import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.sidebarItems = this.el.querySelectorAll('.c-search_sidebar_item');
    }

    setActive(href) {
        this.sidebarItems.forEach(item => {
            item.classList.toggle('is-active', item.getAttribute('href') === href);
        });
    }

    setActiveSection({ way, obj }) {
        if (way !== 'enter') return;

        this.setActive('#' + obj.el.id);
    }
}
